// import moment from 'moment';



export const getLaneCosts = async (webquotecontrol) => {


    let firstTry = await APICall(10000)
    // console.log('getLaneCosts first', firstTry)
    if (typeof firstTry === "object") {
        return firstTry
    } else {
        let secondTry = await APICall(10000)
        // console.log('getLaneCosts second', secondTry)
        if (typeof secondTry === "object") {
            return secondTry
        } else {
            let thridTry = await APICall(10000)
            // console.log('getLaneCosts third', thridTry)
            if (typeof thirdTry === "object") {
                return thridTry
            } else {
                console.warn("getLaneCosts saw an api call fail 3x")
                return 'failed'
            }
        }
    }

    async function APICall(timeOutValue) {

        return new Promise(function (resolve, reject) {

            let controller = new AbortController();

            let url = "https://api.shippersedge.com/analyze/client/kissner/lane-costs"

            let myHeaders = new Headers();
            myHeaders.append("x-api-key", "vdhy8wwjUJrwhxFpfuECTiAW");

            var requestOptions = {
                method: "GET",
                headers: myHeaders,
                redirect: "follow",
            };

            let request = new Request(url, requestOptions);

            if (timeOutValue) {
                setTimeout(() => controller.abort(), timeOutValue);
            }


            fetch(request)
                .then((response) => {
                    // console.log(
                    //   "debug getLaneCosts.js response",
                    //   response
                    // );
                    if (!response.ok) {
                        console.error(
                            "getLaneCosts.js error",
                            response.statusText,
                            response
                        );
                        throw Error(response.statusText);
                    }
                    return response.json();
                })
                .then((response) => {
                    // console.log('getLaneCosts', response)
                    resolve(response);
                })
                .catch((err) => {
                    console.error("getLaneCosts API Request failed", err);
                    resolve(err);
                });
        });
    }
};

export default getLaneCosts